<template>
    <div>
        <rkm-row>
            <rkm-col>
                <rkm-modal
                    large
                    ref="Modal"
                    title="Detalhes"
                >
                    <rkm-alert
                        v-if="solicitacao && !solicitacao.hasOci && !solicitacao.dentroValidadeInserirOci"
                        color="warning"
                    >
                        Não é permitido inserir em protocolo OCI, pois excedeu o tempo de validade.
                    </rkm-alert>

                    <rkm-table
                        :fields="fields"
                        :items="items"
                        hide-filters
                        hide-pagination
                        thead-class="d-none"
                    />

                    <ModalHistoricoMedico ref="ModalHistoricoMedico" />

                    <rkm-row v-if="solicitacao && solicitacao.soapId && model">
                        <rkm-col class="text-right">
                            <rkm-button
                                v-if="hasPermissao('show-ambulatorio-historico-atendimento')"
                                :label="false"
                                @click.stop="$refs.ModalHistoricoMedico.open(model)"
                                color="primary"
                            >
                                Visualizar histórico de atendimento
                            </rkm-button>
                        </rkm-col>
                    </rkm-row>

                    <template v-slot:footer="{cancel}">
                        <rkm-button
                            :disabled="!!loading"
                            @click="cancel"
                        >
                            Fechar
                        </rkm-button>

                        <rkm-button
                            v-if="solicitacao
                                && !solicitacao.hasOci
                                && solicitacao.cidId
                                && solicitacao.dentroValidadeInserirOci
                                && permiteIncluirOci"
                            :disabled="!!loading"
                            @click="$refs.ModalOci.open(solicitacao)"
                            color="primary"
                        >
                            Inserir em protocolo OCI
                        </rkm-button>
                    </template>

                    <ModalOci
                        @save="handleSaveOci"
                        ref="ModalOci"
                    />
                </rkm-modal>
            </rkm-col>
        </rkm-row>
    </div>
</template>

<script>
// Components.
import ModalHistoricoMedico from '@/components/regulacao/solicitacao/components/historico-atendimento-ambulatorio/Modal'
import ModalOci from './components/oci/Modal'

// Vuex.
import {mapActions, mapGetters} from 'vuex'

// Mixins.
import { permissao, repository } from '@/mixins'

export default {
    components: {
        ModalHistoricoMedico,
        ModalOci,
    },
    computed: {
        ...mapGetters({ loading: 'getLoading' }),
        fields() {

            return [
                {
                    key: "field",
                    class: "font-weight-bold col-min",
                },
                {
                    key: "value",
                },
            ]
        }
    },
    created() {
        this.repositories = {
            fila: this.getConectaSusRepository('regulacao.fila')
        }
    },
    data: () => ({
        items: [],
        model: null,
        solicitacao: null,
        permiteIncluirOci: false,
    }),
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        open(item) {

            this.items = [
                {
                    field: 'Unidade solicitante',
                    value: item.unidadeSolicitanteNomeFantasia,
                },
                {
                    field: 'Local de atendimento solicitante',
                    value: item.infraestruturaSolicitanteNome,
                },
                {
                    field: 'Profissional solicitante',
                    value: item.usuarioSolicitanteNome,
                },
                {
                    field: 'HD',
                    value: item.hipoteseDiagnosticaJustificativa,
                },
                {
                    field: 'Data do agendamento',
                    value: item.agendamento,
                },
                {
                    field: 'Usuário que registrou a solicitação',
                    value: item.usuarioRegistrouSolicitacaoNome,
                },
                {
                    field: 'Justificativa da devolução',
                    value: item.justificativaDevolucao,
                },
            ]

            this.solicitacao = item;
            if (this.solicitacao.soapId) this.load();

            this.permiteIncluirOci = false

            if (!this.solicitacao.hasOci) this.loadDadosOci()

            this.$refs.Modal.show()
        },
        hasPermissao(hash) {
            return this.verificarPermissao(hash);
        },
        load() {
            this.setLoading()

            this.repositories.fila.getDadosAmbulatorio(this.solicitacao.id)
                .then(response => {

                    this.model = response.data.form;
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        loadDadosOci() {
            this.setLoading()

            this.repositories.fila.getDadosOci(this.solicitacao.id)
                .then(response => {

                    this.permiteIncluirOci = response.data.permiteIncluirOci;
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        handleSaveOci() {

            this.$refs.Modal.hide()

            this.$emit('save-oci')
        }
    },
    mixins: [permissao, repository],
}
</script>